import { RightIcon } from "@/components/icons/right-icon";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { useIonRouter } from "@ionic/react";
import { memo } from "react";

interface CellItemProps {
  label: string;
  value?: string;
  detail?: string;
  badge?: string;
  href?: string;
  onClick?: () => void;
  showBorder?: boolean;
  classNames?: {
    container?: string;
  };
}

export const CellItem = memo(function CellItem({
  label,
  href,
  value,
  detail,
  badge,
  onClick,
  classNames,
  showBorder = false,
}: CellItemProps) {
  const navigate = useIonRouter();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (onClick) {
      return onClick();
    }
    if (href) {
      return navigate.push(href, "forward", "push");
    }
  };

  return (
    <button
      type="button"
      className={cn(
        "w-full bg-white px-3 py-3.5 text-left",
        "flex items-center justify-between hover:bg-gray-50 active:bg-gray-50",
        {
          "border-li-icon border-b": showBorder,
        },
        classNames?.container,
      )}
      onClick={handleClick}
    >
      <span className={cn(textVariants.bodySmall)}>{label}</span>

      <div className="flex items-center gap-1">
        {value && <span className={cn(textVariants.bodySmall, "text-gray-600")}>{value}</span>}
        {detail && <span className={cn(textVariants.bodySmall, "text-gray-600")}>{detail}</span>}
        {badge && (
          <span
            className={cn(
              "bg-screen-gs-1 rounded-full px-2 py-0.5 text-xs font-semibold text-white",
            )}
          >
            {badge}
          </span>
        )}
        <RightIcon />
      </div>
    </button>
  );
});
